<template>
  <div class="individual-search-inner-container" @click="hideFilters">
    <ais-instant-search
      :search-client="searchClient"
      :index-name="algoliaPrefix + 'LOCATIONS'"
      :initial-ui-state="initialUiState"
      :insights-client="aa"
      :routing="routing"
    >
      <ais-configure
        filters="active:true"
        v-bind="searchParameters"
        :around-lat-lng-via-iP.camel="true"
        :optional-filters.camel="optionalFilters"
        :clickAnalytics="true"
      />

      <div class="block-header bg-cream-gradient pt-md pb-sm">
        <div class="container">
          <div class="row justify-content-center">
            <div class="col-12 col-lg-12">
              <div class="accented-header top-only middle-bar text-center">
                <div class="heading-flex">
                  <h1 class="heading-1 no-max text-uppercase">
                    Find a Location
                  </h1>
                </div>
                <div class="form-spacing">
                  <ais-search-box>
                    <template #submit-icon><div>Search</div></template>
                  </ais-search-box>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div
        class="mobile-filters-button btn btn-primary btn-gold"
        @click.stop="showFilters"
      >
        Filters
      </div>

      <div class="search-content">
        <div class="container">
          <transition name="fade" mode="out-in">
            <div
              class="left-panel-close-backing"
              v-if="showingFilters"
              @click.stop="hideFilters"
            ></div>
          </transition>

          <div
            class="left-panel"
            :class="{ open: showingFilters }"
            @click.prevent.stop
          >
            <div
              class="mobile-filters-close algolia-close"
              @click="hideFilters"
            >
              Close Filters
            </div>

            <div class="pagination-value">
              <ais-stats>
                <template #default="{
                    hitsPerPage,
                    nbPages,
                    nbHits,
                    page,
                    processingTimeMS,
                    query,
                  }"><p
                 
                >
                  Showing {{ page * 8 + 1 }}-{{ page * 8 + 8 }} of
                  {{ nbHits }} results
                </p></template>
              </ais-stats>
            </div>

            <div class="refinement-group">
              <h4>Filter by City</h4>
              <ais-refinement-list attribute="city" :limit="5" show-more>
                <template #default="{
                    items,
                    isShowingMore,
                    isFromSearch,
                    canToggleShowMore,
                    refine,
                    createURL,
                    toggleShowMore,
                    searchForItems,
                  }"><div
                 
                >
                  <ul>
                    <li v-if="isFromSearch && !items.length">No results.</li>
                    <li
                      v-for="item in items"
                      :key="item.value"
                      :class="{ 'is-checked': item.isRefined }"
                    >
                      <a
                        :href="createURL(item)"
                        @click.prevent="refine(item.value)"
                      >
                        <span class="check"></span>
                        <span class="refinement-label">
                          <ais-highlight attribute="item" :hit="item" />
                          <span class="count"
                            >({{ item.count.toLocaleString() }})</span
                          >
                        </span>
                      </a>
                    </li>
                  </ul>

                  <button
                    @click="toggleShowMore"
                    :disabled="!canToggleShowMore"
                    v-if="canToggleShowMore"
                  >
                    {{ !isShowingMore ? "View all" : "View less" }}
                  </button>
                </div></template>
              </ais-refinement-list>
            </div>

            <div class="refinement-group">
              <h4>Filter by Specialty</h4>

              <ais-refinement-list
                attribute="services"
                :sort-by="['name:asc']"
                :limit="5"
                :show-more-limit="100"
                show-more
              >
                <template #default="{
                    items,
                    isShowingMore,
                    isFromSearch,
                    canToggleShowMore,
                    refine,
                    createURL,
                    toggleShowMore,
                    searchForItems,
                  }"><div
                 
                >
                  <ul>
                    <li v-if="isFromSearch && !items.length">No results.</li>
                    <li
                      v-for="item in items"
                      :key="item.value"
                      :class="{ 'is-checked': item.isRefined }"
                    >
                      <a
                        :href="createURL(item)"
                        @click.prevent="refine(item.value)"
                      >
                        <span class="check"></span>
                        <span class="refinement-label">
                          <ais-highlight attribute="item" :hit="item" />
                          <span class="count"
                            >({{ item.count.toLocaleString() }})</span
                          >
                        </span>
                      </a>
                    </li>
                  </ul>

                  <button
                    @click="toggleShowMore"
                    :disabled="!canToggleShowMore"
                    v-if="canToggleShowMore"
                  >
                    {{ !isShowingMore ? "View all" : "View less" }}
                  </button>
                </div></template>
              </ais-refinement-list>
            </div>

            <div class="refinement-group">
              <h4>Filter by Type</h4>

              <ais-refinement-list attribute="type" :limit="5" show-more>
                <template #default="{
                    items,
                    isShowingMore,
                    isFromSearch,
                    canToggleShowMore,
                    refine,
                    createURL,
                    toggleShowMore,
                    searchForItems,
                  }"><div
                 
                >
                  <ul>
                    <li v-if="isFromSearch && !items.length">No results.</li>
                    <li
                      v-for="item in items"
                      :key="item.value"
                      :class="{ 'is-checked': item.isRefined }"
                    >
                      <a
                        :href="createURL(item)"
                        @click.prevent="refine(item.value)"
                      >
                        <span class="check"></span>
                        <span class="refinement-label">
                          <ais-highlight attribute="item" :hit="item" />
                          <span class="count"
                            >({{ item.count.toLocaleString() }})</span
                          >
                        </span>
                      </a>
                    </li>
                  </ul>

                  <button
                    @click="toggleShowMore"
                    :disabled="!canToggleShowMore"
                    v-if="canToggleShowMore"
                  >
                    {{ !isShowingMore ? "View all" : "View less" }}
                  </button>
                </div></template>
              </ais-refinement-list>
            </div>

            <ais-configure :hitsPerPage="8" />
          </div>
          <div class="right-panel">
            <div class="tags-filter-reset">
              <div class="current-filters">
                <ais-current-refinements :transform-items="transformItems" />
              </div>

              <ais-clear-refinements>
                <template #default="{ canRefine, refine, createURL }"><div>
                  <a
                    :href="createURL()"
                    @click.prevent="refine"
                    v-if="canRefine"
                    class="clear"
                  >
                    Clear Filters
                  </a>
                </div></template>
              </ais-clear-refinements>
            </div>

            <ais-hits>
              <template #item="{ item }"><div
               
               
                class="individual-search-result-item individual-search-result-location"
              >
                <div
                  class="item-thumbnail"
                  v-if="item.image"
                  :style="'background-image: url(' + item.image + ')'"
                ></div>
                <div
                  class="item-thumbnail"
                  v-if="!item.image"
                  style="
                    background-image: url(https://monument.health/wp-content/uploads/2021/04/monument-algolia-user-placeholder.jpeg);
                  "
                ></div>

                <div class="item-inner-contents">
                  <div class="item-details">
                    <a :href="item.epic_url || false"
                      ><h3>
                        {{ item.name }}
                        <svg
                          width="6"
                          height="10"
                          viewBox="0 0 6 10"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path
                            d="M1 1L5 5L1 9"
                            stroke="#963821"
                            stroke-width="2"
                            stroke-linecap="round"
                            stroke-linejoin="round"
                          />
                        </svg></h3
                    ></a>
                    <!--                                    <div class="item-services">{{ formatArrayDisplay(item.services, 4) }}</div>-->
                    <!--                                    <div class="item-services">{{  }}</div>-->
                    <div class="item-location">
                      <a
                        :href="`https://www.google.com/maps/search/?api=1&query=${encodeURIComponent(item.address + ', ' + item.city + ', ' + item.state)}`"
                        target="_blank"
                        rel="noopener"
                      >
                        <span
                          v-text="
                            item.address + ', ' + item.city + ', ' + item.state
                          "
                        ></span>
                      </a>

                      <a :href="'tel:' + item.phone" class="item-phone"
                        ><span v-text="formatPhoneNumber(item.phone)"></span
                      ></a>
                    </div>

                    <span v-if="item.dept_id">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="14"
                        height="12"
                        viewBox="0 0 14 12"
                        fill="none"
                      >
                        <path
                          d="M13.125 5.16876C13.2908 5.16876 13.4497 5.10291 13.5669 4.9857C13.6842 4.86849 13.75 4.70952 13.75 4.54376V3.91876C13.75 3.753 13.6842 3.59403 13.5669 3.47682C13.4497 3.35961 13.2908 3.29376 13.125 3.29376H11.8125C11.7795 3.29417 11.7472 3.28411 11.7202 3.26502C11.6933 3.24593 11.6731 3.2188 11.6625 3.18751L10.975 1.12501C10.9102 0.941641 10.7899 0.782977 10.6309 0.670995C10.4719 0.559013 10.282 0.499257 10.0875 0.500007H3.6625C3.46801 0.499257 3.27811 0.559013 3.11909 0.670995C2.96008 0.782977 2.83983 0.941641 2.775 1.12501L2.0875 3.18751C2.07693 3.2188 2.05673 3.24593 2.02978 3.26502C2.00283 3.28411 1.97052 3.29417 1.9375 3.29376H0.625C0.45924 3.29376 0.300268 3.35961 0.183058 3.47682C0.065848 3.59403 0 3.753 0 3.91876V4.54376C0 4.70952 0.065848 4.86849 0.183058 4.9857C0.300268 5.10291 0.45924 5.16876 0.625 5.16876H1.05625C1.08726 5.16996 1.11727 5.18002 1.14275 5.19774C1.16822 5.21546 1.18809 5.2401 1.2 5.26876C1.21615 5.29393 1.22474 5.32322 1.22474 5.35313C1.22474 5.38305 1.21615 5.41233 1.2 5.43751L0.18125 6.41876C0.0670414 6.53853 0.00230218 6.69703 0 6.86251V8.91876C0.00198675 9.0386 0.0383943 9.15535 0.104883 9.25508C0.171371 9.35482 0.265136 9.43333 0.375 9.48126C0.40295 9.49346 0.426719 9.51357 0.443378 9.53911C0.460036 9.56465 0.468856 9.59451 0.46875 9.62501V11.1125C0.470384 11.3192 0.553219 11.517 0.699379 11.6631C0.845539 11.8093 1.0433 11.8921 1.25 11.8938H2.5C2.7067 11.8921 2.90446 11.8093 3.05062 11.6631C3.19678 11.517 3.27962 11.3192 3.28125 11.1125V9.70001C3.28125 9.65857 3.29771 9.61882 3.32701 9.58952C3.35632 9.56022 3.39606 9.54376 3.4375 9.54376H10.3125C10.3539 9.54376 10.3937 9.56022 10.423 9.58952C10.4523 9.61882 10.4688 9.65857 10.4688 9.70001V11.1125C10.4704 11.3192 10.5532 11.517 10.6994 11.6631C10.8455 11.8093 11.0433 11.8921 11.25 11.8938H12.5C12.7067 11.8921 12.9045 11.8093 13.0506 11.6631C13.1968 11.517 13.2796 11.3192 13.2812 11.1125V9.62501C13.2811 9.59451 13.29 9.56465 13.3066 9.53911C13.3233 9.51357 13.3471 9.49346 13.375 9.48126C13.4849 9.43333 13.5786 9.35482 13.6451 9.25508C13.7116 9.15535 13.748 9.0386 13.75 8.91876V6.86251C13.7477 6.69703 13.683 6.53853 13.5687 6.41876L12.5812 5.43751C12.5601 5.4155 12.5459 5.38779 12.5404 5.35781C12.5348 5.32782 12.5382 5.29687 12.55 5.26876C12.5619 5.2401 12.5818 5.21546 12.6073 5.19774C12.6327 5.18002 12.6627 5.16996 12.6937 5.16876H13.125ZM9.75 1.73126C9.78356 1.73222 9.816 1.74355 9.84286 1.76369C9.86972 1.78384 9.88968 1.81181 9.9 1.84376L10.625 4.03126C10.6371 4.05216 10.6434 4.07587 10.6434 4.10001C10.6434 4.12414 10.6371 4.14785 10.625 4.16876C10.6112 4.18895 10.5925 4.20528 10.5706 4.21622C10.5487 4.22716 10.5244 4.23233 10.5 4.23126H3.26875C3.24432 4.23233 3.22002 4.22716 3.19814 4.21622C3.17627 4.20528 3.15755 4.18895 3.14375 4.16876C3.13168 4.14785 3.12533 4.12414 3.12533 4.10001C3.12533 4.07587 3.13168 4.05216 3.14375 4.03126L3.86875 1.84376C3.87907 1.81181 3.89903 1.78384 3.92589 1.76369C3.95275 1.74355 3.98519 1.73222 4.01875 1.73126H9.75ZM3.125 7.98126H1.25C1.16712 7.98126 1.08763 7.94833 1.02903 7.88973C0.970424 7.83112 0.9375 7.75164 0.9375 7.66876V7.04376C0.9375 6.96088 0.970424 6.88139 1.02903 6.82279C1.08763 6.76418 1.16712 6.73126 1.25 6.73126H3.125C3.20788 6.73126 3.28737 6.76418 3.34597 6.82279C3.40458 6.88139 3.4375 6.96088 3.4375 7.04376V7.66876C3.4375 7.75164 3.40458 7.83112 3.34597 7.88973C3.28737 7.94833 3.20788 7.98126 3.125 7.98126ZM10.3125 7.04376C10.3125 6.96088 10.3454 6.88139 10.404 6.82279C10.4626 6.76418 10.5421 6.73126 10.625 6.73126H12.5C12.5829 6.73126 12.6624 6.76418 12.721 6.82279C12.7796 6.88139 12.8125 6.96088 12.8125 7.04376V7.66876C12.8125 7.75164 12.7796 7.83112 12.721 7.88973C12.6624 7.94833 12.5829 7.98126 12.5 7.98126H10.625C10.5421 7.98126 10.4626 7.94833 10.404 7.88973C10.3454 7.83112 10.3125 7.75164 10.3125 7.66876V7.04376Z"
                          fill="#963821"
                        />
                      </svg>
                      <a
                        :href="`https://mychart.monument.health/MyChart/scheduling/onmyway`"
                        class="item-control-link on-my-way"
                        target="_blank"
                        >I'm on my way</a
                      >
                    </span>
                  </div>

                  <div class="item-controls">
                    <a
                      v-if="item.epic_url"
                      :href="item.epic_url"
                      target="_blank"
                      class="item-control-link"
                      >Find a Provider</a
                    >
                  </div>
                </div>
              </div></template>
            </ais-hits>

            <div class="search-results-pagination bg-white">
              <ais-pagination
                :show-first="false"
                :show-previous="true"
                :show-next="true"
                :show-last="false"
              />

              <ais-stats>
                <template #default="{
                    hitsPerPage,
                    nbPages,
                    nbHits,
                    page,
                    processingTimeMS,
                    query,
                  }"><p
                 
                >
                  Showing {{ page * 8 + 1 }}-{{ page * 8 + 8 }} of
                  {{ nbHits }} results
                </p></template>
              </ais-stats>
            </div>
          </div>
        </div>
      </div>
    </ais-instant-search>
  </div>
</template>

<script>
const aa = require("search-insights");
// window.aa = aa;
import algoliasearch from "algoliasearch";

const algoliaPrefix =
  window.ajax_global && window.ajax_global.algolia_prefix
    ? window.ajax_global.algolia_prefix
    : "prod_";
const searchClient = algoliasearch(
  "O4J2BVWP7X",
  "25e82b9ff49bfc98eeaea844742d9654",
);
const index = searchClient.initIndex(algoliaPrefix + "LOCATIONS");

export default {
  props: ["query_in"],

  data() {
    return {
      query: "",
      originalQuery: "",
      algoliaPrefix,
      searchClient,
      index,
      initialUiState: {
        [algoliaPrefix + "LOCATIONS"]: {
          query: this.query_in,
          refinementList: ["active:true"],
        },
      },
      optionalFilters: [
        "type:Medical Clinics<score=4>",
        "type:Urgent Cares<score=3>",
        "type:Specialty & Surgical Centers,<score=2>",
        "type:Hospitals",
      ],
      searchParameters: {},
      showingFilters: false,
      routing: {
        stateMapping: {
          stateToRoute(uiState) {
            const indexUiState = uiState[algoliaPrefix + "LOCATIONS"] || {};
            return {
              query: indexUiState.query,
              services: indexUiState.refinementList?.services,
              city: indexUiState.refinementList?.city,
              type: indexUiState.refinementList?.type,
              page: indexUiState.page,
            };
          },
          routeToState(routeState) {
            return {
              [algoliaPrefix + "LOCATIONS"]: {
                query: routeState.query,
                refinementList: {
                  services: routeState.services,
                  city: routeState.city,
                  type: routeState.type,
                },
                page: routeState.page,
              },
            };
          },
        },
      },
    };
  },

  mounted() {
    this.query = this.query_in;
    this.originalQuery = this.query_in;
  },

  components: {},

  watch: {},

  methods: {
    transformItems: function (items) {
      // console.log(items);
      for (let i = 0; i < items.length; i++) {
        if (items[i].label === "services") {
          items[i].label = "Specialty";
        } else if (items[i].label === "last_name_letter") {
          items[i].label = "Last Name";
        }
      }
      return items;
      // return items.filter(item => item.attribute !== 'brand');
    },

    formatPhoneNumber: function (phoneNumberString) {
      var cleaned = ("" + phoneNumberString).replace(/\D/g, "");
      var match = cleaned.match(/^(\d{3})(\d{3})(\d{4})$/);
      if (match) {
        return "(" + match[1] + ") " + match[2] + "-" + match[3];
      }
      return null;
    },

    formatArrayDisplay: function (array, maxLength = 0) {
      let returnString = "";

      if (maxLength > 0 && array.length > maxLength) {
        for (let i = 0; i < maxLength - 1; i++) {
          if (returnString === "") {
            returnString += this.decodeHTMLEntities(array[i]);
          } else {
            returnString += ", " + this.decodeHTMLEntities(array[i]);
          }
        }
        returnString += " + more";
      } else {
        for (let i = 0; i < array.length; i++) {
          if (returnString === "") {
            returnString += this.decodeHTMLEntities(array[i]);
          } else {
            returnString += ", " + this.decodeHTMLEntities(array[i]);
          }
        }
      }

      return returnString;
    },

    decodeHTMLEntities: function (text) {
      var entities = [
        ["amp", "&"],
        ["apos", "'"],
        ["#x27", "'"],
        ["#x2F", "/"],
        ["#39", "'"],
        ["#47", "/"],
        ["lt", "<"],
        ["gt", ">"],
        ["nbsp", " "],
        ["quot", '"'],
      ];

      for (var i = 0, max = entities.length; i < max; ++i)
        text = text.replace(
          new RegExp("&" + entities[i][0] + ";", "g"),
          entities[i][1],
        );

      return text;
    },

    showFilters: function () {
      this.showingFilters = true;
    },

    hideFilters: function () {
      this.showingFilters = false;
    },
  },
};
</script>
